"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _menuEntrySettings = _interopRequireDefault(require("./menu-entry-settings"));

var _removeDuplicatesEntry = _interopRequireDefault(require("./remove-duplicates-entry"));

var _menuEntryExport = _interopRequireDefault(require("./menu-entry-export"));

var _authorisation = _interopRequireDefault(require("./../authorisation"));

var _translate = _interopRequireDefault(require("./../translate"));

var _menuEntryReset = _interopRequireDefault(require("./menu-entry-reset"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SettingsEntry = new new _authorisation.default(['admin'], [], false)(_menuEntrySettings.default);
var RemoveDuplicatesEntry = new new _authorisation.default(['admin'], [], false)(_removeDuplicatesEntry.default);
var ExportEntry = new new _authorisation.default(['admin', 'projectresponsible', 'cantonresponsible'], ['schub', 'vomhof', 'stallvisite', 'lockpfosten', 'brunch', 'toh'], false)(_menuEntryExport.default);
var ResetEntry = new new _authorisation.default(['admin', 'projectresponsible'], ['brunch', 'lockpfosten', 'toh'], false)(_menuEntryReset.default);

var MainMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(MainMenu, _React$Component);

  function MainMenu(props) {
    var _this;

    _classCallCheck(this, MainMenu);

    _this = _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).call(this, props));
    _this.state = {
      path: _this.props.location.path
    };
    _this.isActive = _this.isActive.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MainMenu, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "main-nav"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: "main-nav__item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "/",
        className: 'main-nav__link ' + this.isActive('/')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-home"
      }))), /*#__PURE__*/_react.default.createElement("li", {
        className: "main-nav__item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "/projects",
        title: t('Projects'),
        onClick: function onClick() {
          return localStorage.clear();
        },
        className: 'main-nav__link ' + this.isActive('/projects')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-projects"
      }))), /*#__PURE__*/_react.default.createElement("li", {
        className: "main-nav__item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "/farms",
        title: t('farms'),
        onClick: function onClick() {
          return localStorage.clear();
        },
        className: 'main-nav__link ' + this.isActive('/farms')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-farm"
      }))), /*#__PURE__*/_react.default.createElement("li", {
        className: "main-nav__item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "/users",
        title: t('User'),
        onClick: function onClick() {
          return localStorage.clear();
        },
        className: 'main-nav__link ' + this.isActive('/users')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-user"
      }))), /*#__PURE__*/_react.default.createElement(RemoveDuplicatesEntry, {
        t: t,
        location: this.props.location
      }), /*#__PURE__*/_react.default.createElement(SettingsEntry, {
        t: t,
        location: this.props.location
      }), /*#__PURE__*/_react.default.createElement(ExportEntry, {
        location: this.props.location,
        text: t('Exporte')
      }), /*#__PURE__*/_react.default.createElement(ResetEntry, {
        location: this.props.location,
        text: t('menu project admin')
      }), /*#__PURE__*/_react.default.createElement("li", {
        className: "main-nav__item"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: t('Logout'),
        href: "/logout",
        className: "main-nav__link"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon-logout"
      }))));
    }
  }, {
    key: "isActive",
    value: function isActive(path) {
      return this.props.location.pathname === path ? 'is-active' : '';
    }
  }]);

  return MainMenu;
}(_react.default.Component);

MainMenu.propTypes = {
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string,
    path: _propTypes.default.string
  }),
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(MainMenu);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/main-menu/index.js
// module id = 708
// module chunks = 0